import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          精彩预告
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          独家内容与精选专题，影迷不可错过的精彩
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-lg overflow-hidden border border-background-300/40 bg-background-100/60 transition-all duration-300 hover:border-primary-500/30"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center transition-transform duration-200 group-hover:scale-110 cursor-pointer">
                    <i className="ri-play-fill text-white text-xl md:text-2xl ml-1"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-background-950/70 text-foreground-200 rounded-full">
                    预告片
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}